import { build } from "app/main/tools/ConfigBuilder";
import { lazy } from "react";

export default build([
	{
		path: "/v3/driver-payroll",
		component: lazy(() => import("./EnterpriseDriversPayrollPage")),
	},
]);
